//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import Select2 from "@Shared/components/inputs/select2.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LanguagePreferences",
  components: {
    MaterialInput,
    Select2
  },
  mixins: [validationMixin],
  validations: {
    localeLanguage: {
      required
    }
  },
  props: {
    accountDetails: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localeLanguage: this.accountDetails.localeLanguage
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    localeLanguageOptions() {
      return [{
        text: this.$t("global.words.english"),
        id: "en-CA"
      }, {
        text: this.$t("global.words.french"),
        id: "fr-CA"
      }];
    },
    select2Options() {
      return {
        closeOnSelect: true,
        minimumResultsForSearch: -1,
        placeholder: "Preferred Language"
      };
    }
  },
  watch: {
    isFormValid: {
      handler(valid) {
        this.$emit("allow-save", valid);
      }
    }
  },
  methods: {
    handleLocaleChange({
      id
    }) {
      this.localeLanguage = id;
      this.handleFormChange();
    },
    handleInitialSubmit() {
      this.$emit("initial-submit");
    },
    handleSubmit() {
      if (this.isFormValid) {
        this.$emit("submit", {
          localeLanguage: this.localeLanguage
        });
      }
    },
    handleFormChange() {
      this.$emit("form-change", "languagePreferences");
      this.$emit("allow-save", true);
    }
  }
});